<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <strong>Seleccione las muestras que desea enviar a Revisión</strong>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="card" v-if="detailNew.filter(
                        (x) =>
                            x.rejectToWinderyDispatch == null &&
                            x.rejectAt == null &&
                            x.cancelledAt == null &&
                            x.wineryValidatedAt == null
                    ).length > 0
                        ">
                        <div class="card-header">
                            <h4>Nuevo Producto</h4>
                        </div>

                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                        <th style="width: 3%"></th>
                                        <th style="width: 30%">Motivo</th>
                                    </tr>
                                </thead>

                                <tbody v-for="item in detailNew.filter(
                                    (x) =>
                                        x.rejectToWinderyDispatch == null &&
                                        x.rejectAt == null &&
                                        x.cancelledAt == null &&
                                        x.wineryValidatedAt == null
                                )" :key="item.id">
                                    <tr>
                                        <td>{{ item.id }}{{ item.brand }}</td>

                                        <td v-if="item.comercialMixCode && !item.isNewComposition">
                                            {{ item.comercialMixCode }} {{ item.comercialMix }}
                                        </td>

                                        <td v-if="!item.comercialMixCode && item.isNewComposition">
                                            Nueva Composición
                                        </td>

                                        <td>
                                            {{ item.variety }} {{ item.valley }}
                                            {{ item.quality }}
                                        </td>

                                        <td>{{ item.finalHarvest }}</td>
                                        <td>{{ item.quantity }}</td>

                                        <td>
                                            <input class="form-control" type="checkbox" :id="'check-rev-' + item.id" />
                                        </td>

                                        <td>
                                            <textarea class="form-control" :id="'reason-rev-' + item.id"
                                                placeholder="Motivo de envío a Revisión"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <br />

                    <div class="card" v-if="detailFinish.filter(
                        (x) =>
                                    x.rejectToWinderyDispatch == null &&
                                    x.rejectAt == null &&
                                    x.cancelledAt == null &&
                                    x.wineryValidatedAt == null
                            ).length > 0
                        ">
                        <div class="card-header">
                            <h4>Producto Terminado</h4>
                        </div>

                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                        <th style="width: 3%"></th>
                                        <th style="width: 30%">Motivo</th>
                                    </tr>
                                </thead>

                                <tbody v-for="item in detailFinish.filter(
                                    (x) =>
                                        x.rejectToWinderyDispatch == null &&
                                        x.rejectAt == null &&
                                        x.cancelledAt == null &&
                                        x.wineryValidatedAt == null
                                )" :key="item.id">
                                    <tr>
                                        <td>{{ item.id }} {{ item.brand }}</td>

                                        <td>{{ item.comercialMixCode }} {{ item.comercialMix }}</td>

                                        <td>
                                            {{ item.variety }} {{ item.valley }}
                                            {{ item.quality }}
                                        </td>

                                        <td>{{ item.finalHarvest }}</td>
                                        <td>{{ item.quantity }}</td>

                                        <td>
                                            <input class="form-control" type="checkbox" :id="'check-rev-' + item.id" />
                                        </td>

                                        <td>
                                            <textarea class="form-control" :id="'reason-rev-' + item.id"
                                                placeholder="Motivo de envío a Revisión"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <br />

                    <div class="card" v-if="detailBottle.filter(
                        (x) =>
                            x.rejectToWinderyDispatch == null &&
                            x.rejectAt == null &&
                            x.cancelledAt == null &&
                            x.wineryValidatedAt == null
                    ).length > 0
                        ">
                        <div class="card-header">
                            <h4>Guarda Botella</h4>
                        </div>

                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>

                                        <th>Vino</th>

                                        <th>Botella</th>

                                        <th style="width: 3%"></th>

                                        <th style="width: 30%">Motivo</th>
                                    </tr>
                                </thead>

                                <tbody v-for="item in detailBottle.filter(
                                    (x) =>
                                        x.rejectToWinderyDispatch == null &&
                                        x.rejectAt == null &&
                                        x.cancelledAt == null &&
                                        x.wineryValidatedAt == null
                                )" :key="item.id">
                                    <tr>
                                        <td>{{ item.brand }}</td>

                                        <td>
                                            {{ item.variety }} {{ item.valley }}
                                            {{ item.quality }}
                                        </td>

                                        <td>{{ item.finalHarvest }}</td>
                                        <td>{{ item.quantity }}</td>

                                        <td>
                                            <input class="form-control" type="checkbox" :id="'check-rev-' + item.id" />
                                        </td>

                                        <td>
                                            <textarea class="form-control" :id="'reason-rev-' + item.id"
                                                placeholder="Motivo de envío a Revisión"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <button @click="sendRevisionSamples" class="btn btn-block btn-success">
                        <i class="fa fa-send"></i>

                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
export default {
    props: ["detailFinish", "detailNew", "detailBottle", "sampleToSendRevision"],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
        };
    },
    methods: {
        sendRevisionSamples() {
            let sendToRevison = true;
            this.detailNew
                .filter(
                    (x) =>
                        x.rejectToWinderyDispatch == null &&
                        x.rejectAt == null &&
                        x.cancelledAt == null
                )
                .forEach((itemNew) => {
                    let is_checked = $("#check-rev-" + itemNew.id).is(":checked");
                    if (is_checked) {
                        if (
                            !$("#reason-rev-" + itemNew.id).val() ||
                            $("#reason-rev-" + itemNew.id).val() === ""
                        ) {
                            window.toastr.warning(
                                "Debe ingresar un motivo del envio a revision"
                            );
                            sendToRevison = false;
                        } else {
                            itemNew.wineSample = true;
                            itemNew.reasonSendToRevision = $(
                                "#reason-rev-" + itemNew.id
                            ).val();
                        }
                    }
                });
            this.detailFinish
                .filter(
                    (x) =>
                        x.rejectToWinderyDispatch == null &&
                        x.rejectAt == null &&
                        x.cancelledAt == null
                )
                .forEach((item) => {
                    let is_checked = $("#check-rev-" + item.id).is(":checked");
                    if (is_checked) {
                        if (
                            !$("#reason-rev-" + item.id).val() ||
                            $("#reason-rev-" + item.id).val() === ""
                        ) {
                            window.toastr.warning(
                                "Debe ingresar un motivo del envio a revision"
                            );
                            sendToRevison = false;
                        } else {
                            item.wineSample = true;
                            item.reasonSendToRevision = $("#reason-rev-" + item.id).val();
                        }
                    }
                });
            this.detailBottle
                .filter(
                    (x) =>
                        x.rejectToWinderyDispatch == null &&
                        x.rejectAt == null &&
                        x.cancelledAt == null
                )
                .forEach((item) => {
                    let is_checked = $("#check-rev-" + item.id).is(":checked");
                    if (is_checked) {
                        if (
                            !$("#reason-rev-" + item.id).val() ||
                            $("#reason-rev-" + item.id).val() === ""
                        ) {
                            window.toastr.warning(
                                "Debe ingresar un motivo del envio a revision"
                            );
                            sendToRevison = false;
                        } else {
                            item.wineSample = true;
                            item.reasonSendToRevision = $("#reason-rev-" + item.id).val();
                        }
                    }
                });
            if (sendToRevison) {
                this.$emit("sendRevisionSamples");
            }
        },
    },
};
</script>
  